import defaultTheme from './default';
import light from './light';
import mailwise from './mailwise';
var themes = {
    default: defaultTheme,
    light: light,
    mailwise: mailwise
};
export default themes;
